/**
 * Queries all elements matching the given selectors within the root element.
 * @param {string} selectors - The CSS selectors to match.
 * @param {HTMLElement} [root=document.body] - The root element to query within.
 * @returns {HTMLElement[]} An array of matched elements.
 */
export function queryAll(selectors, root = document.body) {
	return [...root.querySelectorAll(selectors)];
}

/**
 * Queries the first element matching the given selectors within the root element.
 * @param {string} selectors - The CSS selectors to match.
 * @param {HTMLElement} [root=document.body] - The root element to query within.
 * @returns {HTMLElement|null} The first matched element or null if no match is found.
 */
export function query(selectors, root = document.body) {
	return root.querySelector(selectors);
}
